module.exports = __webpack_public_path__ + "static/media/SVGSpriteIcon.e1920ddc.svg";